import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { FdrRoute } from '@hotelplan/fdr.regular.basis.fdr-route';
import { card } from '@hotelplan/components.common.mixins';
import { FdrStyledTextBlock } from 'fdr/components/local/fdr-styled-text-block';

export const FdrThemePreviewsWrapper = styled.div(({ theme: { colors } }) => ({
  backgroundColor: colors.bgLightBlue,
}));

export const FdrThemesContainer = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    pt: ['30px', '45px'],
    mx: [4, '-15px'],
    flexWrap: 'wrap',
  })
);

export const FdrThemeItem = styled.div(
  sx2CssThemeFn({
    width: ['100%', 'calc(100% / 3)'],
    px: [null, '15px'],
    pb: [6, '45px'],
    '> a:first-child': {
      height: ['auto', 'calc(100% - 48px)'], // (fontSize * lineHeight) + marginTop - borderWidth * 2
    },
  })
);

export const FdrLinkWrapper = styled(FdrRoute)(
  ({ theme: { FONT_SIZE, colors } }) =>
    sx2CssThemeFn({
      ...FONT_SIZE.LINK_LARGE,
      display: 'flex',
      alignItems: 'center',
      mt: '20px',
      textDecoration: 'underline',
      textDecorationColor: colors.linkUnderlineColor,
      textUnderlineOffset: '6px',
      color: colors.defaultText,
      transition: 'none',
      transform: 'translate(0)',
      '&:hover,&:focus': {
        color: colors.defaultText,
        textDecorationColor: colors.defaultText,
        transform: 'scale(1)',
      },

      '.theme-card-icon': {
        ml: 3,
        variant: 'icons.lg',
      },
    })
);

export const fdrCardContentStyles = sx2CssThemeFn({
  flexDirection: 'column',
  flex: '1 auto',
  width: '100%',
  height: '100%',
  borderRadius: 'default',
  border: '1px solid',
  borderColor: 'borderGreyFifth',
  zIndex: ['0', '1'],
  backgroundColor: 'background',
});

export const FdrBlockLink = styled(FdrRoute)(
  ({ theme }) => theme.link.blockLink
);

export const FdrCardContentWrapper = styled.div(
  {
    display: 'flex',
    '.card-content-wrap': {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 auto',
    },
  },
  sx2CssThemeFn(card),
  fdrCardContentStyles
);

export const FdrThemeLeadTextBlock = styled(FdrStyledTextBlock)(
  sx2CssThemeFn({
    pt: [5, '70px'],
    pb: [5, '55px'],
    px: [4, 0],
  })
);
